import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authReducer";
import studentManagementReducer from "./slices/studentManagementReducer";
import feedmanagement from "./slices/feedmanagement";
import staticContentManagement from "./slices/staticContentManagement";
import faqManagement from "./slices/faqManagement";
import categoryManagement from "./slices/categoryManagement";
import topicDetails from "./slices/topicSlice";
import LivestreamManagement from "./slices/liveStream";
import coursesManagement from "./slices/coursesManagement";
import subAdmin from "./slices/subAdmin";
import chapterManagement from "./slices/chapterManagement";
import lectureVideoManagement from "./slices/lectureVideoManagement";
import courseDetailsManagement from "./slices/courseDetails";
import challengesStatus from "./slices/challanges";
import podcast from "./slices/poadcast";
import studentFeed from "./slices/studentManagement/studentFeed";
import studentLiveStream from "./slices/studentManagement/studentLiveStream";
import studentChallange from "./slices/studentManagement/studentChallange";
import studentCourse from "./slices/studentManagement/studentCourse";
import studentpodcast from "./slices/studentManagement/studentpodcast";
import notification from "./slices/notification";
import dashboard from "./slices/dashboard";
const store = configureStore({
  reducer: {
    auth: authReducer,
    student: studentManagementReducer,
    feed: feedmanagement,
    staticContent: staticContentManagement,
    FAQ: faqManagement,
    category: categoryManagement,
    topic: topicDetails,
    liveStream: LivestreamManagement,
    courses: coursesManagement,
    subAdmin: subAdmin,
    chapter: chapterManagement,
    lectureVideo: lectureVideoManagement,
    courseDetails: courseDetailsManagement,
    challenges: challengesStatus,
    podcast: podcast,
    studentFeed: studentFeed,
    studentLiveStream: studentLiveStream,
    studentChallange: studentChallange,
    studentCourse: studentCourse,
    studentpodcast: studentpodcast,
    notification: notification,
    dashboard: dashboard,
  },
});
export default store;
